import { connect } from 'react-redux';
import options from '../../state/options/options.actions';
import ScreenWrapper from './screenWrapper.ui';

const mapStateToProps = (state: Object) => ({
    isFullScreen: state.options.isFullScreen,
});

const mapDispatchToProps = (dispatch: any): Object => ({
    fullScreen(isFullScreen) {
        dispatch(options.fullScreen(isFullScreen));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ScreenWrapper);
